import React, { Component } from 'react';

class FFFModal extends Component {
  render() {
    const { onFFFSaveYes, onFFFSaveNo } = this.props;
    return (
      <div
        className="modal fade theme-modal qty-modal"
        id="FFFModal"
        tabIndex="-1"
        aria-labelledby="FFFModal"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              <h5 className="modal-title m-0 mt-2">
                Post Decontamination & Form Fit Function Acknowledgement
              </h5>
              <h5 className="modal-title m-0 mb-2">I certify that:</h5>
              <p>1 - I retrieved product to be removed from the hospital from the
                post - decontamination area after surgery and visually verified to
                ensure no gross soiling AND
              </p>
              <p>
                I inspected product to be removed from the hospital for residual
                debris, functionality or damage, and completeness.
              </p>
              <p>OR </p>
              <p>2 - I confirm product was NOT removed from hospital. </p>
            </div>
            <div className="modal-footer">
              <div className="row gx-2 button-wrap">
                <div className="col-6">
                  <button
                    type="button" className="btn btn-link btn-left w-100"
                    data-bs-dismiss="modal"
                    onClick={() => onFFFSaveNo()}
                  >Cancel
                  </button>
                </div>
                <div className="col-6">
                  <button
                    type="button" className="btn btn-link w-100"
                    onClick={() => onFFFSaveYes()}
                  >Confirm
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FFFModal;
